module.exports = __webpack_public_path__ + "assets/98bea41fc15cdf637a9f62cab273e8f7.svg";